import { FC } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuthContext } from "@/context/AuthContext.tsx";
import Middleware from "@/router/middleware/index.tsx";
import OnboardingStep from "$/_const/OnboardingStep.ts";
import { onboardingRouteFor } from "@/utils/onboarding/onboardingRoute.ts";

const OnboardingFinished: FC = () => {
  const { user, isLoading } = useAuthContext();

  const isOnboardingFinished =
    user?.onboarding_step === OnboardingStep.FINISHED;

  return (
    <Middleware isLoading={isLoading}>
      {isOnboardingFinished ? <Outlet /> : <Navigate to={onboardingRouteFor(user?.onboarding_step)} />}
    </Middleware>
  );
};

export default OnboardingFinished;
